import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService, TiposCalculos, EstatusCreditos } from '../../../../../services/tools/helpers.service';
import { PagosService } from '../../../../../services/pagos.service';
import { ArchivosPagosService } from "../../../../../services/archivos-pagos.service";
import { CreditosService } from "../../../../../services/creditos.service";
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'agregar-pago',
  templateUrl: './agregar-pago.component.html'
})
export class AgregarPagoComponent implements OnInit {
  @Input() public idCreditos : number = null;
  @Input() public isValidToAddPago : number = null;
  @ViewChild('closeBtn') closeBtn: ElementRef;
  @ViewChild('editarPagoBtn') editarPagoBtn: ElementRef;
  @Output() public onPagoCreated : EventEmitter<string> = new EventEmitter;

  //Cliente form
  public errors: any = {};
  public pago: any = { forma: '', tipo_abono: '', porcentaje_descuento: null};
  public tipoPagoSelected: any = '';
  public opcionesPagos: any []  = [];
  public archivo: any = null;
  public tiposAbonos: any[] = [];

  //helpers
  public loadingTiposPagos: boolean = false;

  constructor(
    private helperService: HelpersService,
    private pagosService: PagosService,
    private archivosService: ArchivosPagosService,
    private creditosService: CreditosService
  ){
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.idCreditos && this.idCreditos) {
      this.getCredito(this.idCreditos);
    }
  }

  private getCredito(idCreditos : number){
    this.creditosService.get(idCreditos).subscribe(
        (response)=>
        {
          const credito = response.json().content;
          this.setupTiposAbono(credito.prestamo.calculo);
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
    );
  }

  public getOpcionesPago(){
    //Si se esta editando un pago debemos enviar el id del pago para que se calculen las opciones de pago excluyendo el monto del pago realizado
    let idPago = this.pago.id ? this.pago.id : null;
    //Si se ha ingresado un descuento se obtienen las opciones aplicando este descuento
    let porcentaje_descuento = this.pago.porcentaje_descuento ? this.pago.porcentaje_descuento : null;
    //Seleccionamos la opción default de los tipos de pagos (ya que se recargará el combo)
    this.tipoPagoSelected = '';
    this.loadingTiposPagos = true;

    this.pagosService.getOpcionesPago(this.idCreditos, idPago, porcentaje_descuento).subscribe(
      (response)=>
      {
        const opcionesPago = response.json().content;
        this.opcionesPagos = opcionesPago;
        this.loadingTiposPagos = false;
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        this.loadingTiposPagos = false;
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getArchivoPago(idPago: number){
    const ctrl = this;
    this.archivosService.get(idPago).subscribe(
      (response)=>
      {
        const archivos = response.json().content;
        if(archivos.length){
          this.archivo = archivos[0];
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public save(){
    this.errors = {};
    let pago = this.pago;

    //Asignarel tipo de pago con base en el item que este seleccionado
    let ctrl = this;
    pago.monto_pago = null;
    pago.tipo = null;
    this.opcionesPagos.forEach(function(tipoPago) {
      if(tipoPago.opcion === ctrl.tipoPagoSelected.opcion){
        pago.monto_pago = tipoPago.monto;
        pago.tipo = tipoPago.opcion;
      }
    });

    //Si no fue definido el descuento asignamos null. Si ominitmos esta asignación se generá un error en el backend
    this.pago.porcentaje_descuento = pago.porcentaje_descuento ? pago.porcentaje_descuento : null;

    this.errors = this.pagosService.validate(pago);

    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    //Si no se ingreso un valor en el campo de abono, seteamos estos campos como null
    if(!this.pago.abono || this.pago.abono.toString().length == 0){
      this.pago.tipo_abono = null;
      this.pago.abono = null;
    }

    if(pago.id){
      //Update pago
      this.update(pago);
    }else{
      //New pago
      //Set idCreditos
      pago.idCreditos = this.idCreditos;
      this.create(pago);
    }
  }

  private create(pago : any){
    this.pagosService.save(pago).subscribe(
      (response)=>
      {
        const result = response.json().content;
        this.helperService.notification('Pago creado', 'Se ha registrado exitosamente el pago', 'success');
        this.setupAfterSave();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        if(error.status == 400) {
          this.showBackendError(error.json().content);
        }
      }
    );
  }

  private update(pago: any){
    this.pagosService.update(pago).subscribe(
      (response)=>
      {
        const result = response.json().content;
        this.helperService.notification('Pago actualizado', 'Se ha actualizado exitosamente el pago', 'success');
        this.setupAfterSave();
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.showBackendError(error.json().content);
        }
      }
    );
  }

  private showBackendError(jsonErrors: any){
    if(jsonErrors.abono){
      this.errors["abono"] = jsonErrors.abono;
      this.errors["tipo"] = jsonErrors.abono;
    }
  }

  public showModalPago(idPago: number){
    this.resetPagoModel();
    //Abrir el modal para editar un pago
    this.editarPagoBtn.nativeElement.click();
    //Cargar los datos del pego a editar
    if(idPago){  
      this.getOpcionesPagoAndPagoDetails(idPago);
      //La info del archivo se puede cargar de forma asincróna. Ya que no afecta si se obtiene antes o después que los otros datos
      this.getArchivoPago(idPago);
    }
  }

  /**
   * Esta función obtiene las opciones de pago y después los detalles del pago.
   * Se requiere que esta información se cargue de manera secuencial, ya que de lo contrario en el combo de tipo de pago
   * no se selecciona la opción correcta
   */
  private getOpcionesPagoAndPagoDetails(idPago: number){
    const ctrl = this;

    //1. Primero se consultan los detallos del pago a editar
    this.pagosService.getPago(idPago).pipe(
      switchMap(pagoResponse => {
        const pago = pagoResponse.json().content;
        ctrl.pago = pago;

        //2. Después se consultan las opciones de pago, para seleccionar la que se utilizó
        return this.pagosService.getOpcionesPago(ctrl.idCreditos, idPago, ctrl.pago.porcentaje_descuento)
      })
    ).subscribe(
      opciones => {
        //Fill dd con opciones de pago
        ctrl.opcionesPagos = opciones.json().content;        

        //Selecciona el tipo de pago, para mostrar la opción correcta en el combo
        ctrl.opcionesPagos.forEach(function(tipoPago) {
          if(tipoPago.opcion === ctrl.pago.tipo){
            ctrl.tipoPagoSelected = tipoPago;
          }
        });
      
    }, error =>
    {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);
      
      if(error.status == 400) {
        this.helperService.setBackendErrors(error.json().content, this.errors);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    });
  }

  private setupAfterSave(){
    this.onPagoCreated.emit();
    //Cerrar el modal
    this.closeBtn.nativeElement.click();
    this.resetPagoModel();  
  }

  public setupForNewPago(){
    this.resetPagoModel();
    //Obtener las opciones de pago, ya que despúes de un pago estas pueden haber cambiado
    this.getOpcionesPago();
  }

  private resetPagoModel(){
    //se restablecen los valores del pago para que la siguiente ves que se abra el modal, tenga los valores default
    this.tipoPagoSelected = '';
    
    //Reiniciamos el valor de las propiedades de un pago
    this.pago = { forma: '', tipo_abono: '' };

    //Limpiar la relación con el archivo
    this.archivo = null;
    //Clear errors
    this.errors = [];
  }

  /**
   * Upload files
   */
  public uploadFile(event : any) {

    let fileInfo = 
    {
        idPagos : (this.pago.id) ? this.pago.id : null
    };
    
    let observableResponse = this.archivosService.save(event, fileInfo);
    if(!observableResponse){
      return;
    }

    observableResponse.subscribe(
        (response)=>
        {
          let archivo = response.json().content;
          //Se agrega la info del nuevo archivo a la lista para que se muestre en el formulario
          this.pago.idArchivo = archivo.id;
          this.archivo = archivo;

          //Notify result
          this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {            
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );   
  }

  public downloadFile() {
    this.archivosService.getFile(this.archivo.id).subscribe(
      (response)=>
      {
        const fileUrl = window.URL.createObjectURL(response.blob());
        //Muestra el archivo en una nueva ventana
        window.open(fileUrl);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  
  public deleteFile(){

    this.archivosService.delete(this.archivo.id).subscribe(
      (response)=>
      {
        //Si el archivo fue eliminado, desasignamos el valor del atributo contratoFile
        this.archivo = null;
        this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private setupTiposAbono(calculo: number){
    let tiposAbonos = [];
    switch(calculo){
      case TiposCalculos.Simple:
          tiposAbonos.push({
          'value': 2,
          'label': 'Reducir el monto de los siguientes pagos'
        });
        break;
      case TiposCalculos.Insoluto:
      case TiposCalculos.Soluto:
      case TiposCalculos.MesesSinIntereses:
          tiposAbonos.push({
          'value': 1,
          'label': 'Reducir número de plazos'
        });
        tiposAbonos.push({
          'value': 2,
          'label': 'Reducir el monto de los siguientes pagos'
        });
        break;
    }

    this.tiposAbonos = tiposAbonos;
  }

  public print(){
    //Imprimir pantalla
    window.print();
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/tabla-pagos/components/agregar-pago/agregar-pago.component.ts